// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__26d1t","header":"MessagesList_header__3OapA","chat":"MessagesList_chat__3kDvS"};